import { Pipe, PipeTransform } from '@angular/core';
import { SenderDomain } from '@vendasta/email';
import { DEFAULT_SENDER_DOMAIN } from '../sender-info-card/sender-info-form/default';

@Pipe({
  name: 'canAddDomain',
})
export class CanAddDomainPipe implements PipeTransform {
  transform(value: SenderDomain[]): boolean {
    if (!value) {
      return true;
    }
    const nonDefault = value.filter((d) => d.sendFromDomain !== DEFAULT_SENDER_DOMAIN);
    const hasPending = nonDefault.map((d) => !d.isPrimary).some((isPending) => isPending);
    return hasPending === false;
  }
}
